module.exports = __webpack_public_path__ + "img/insec_Torture.01f94cd4.svg";